import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

// One table per Leads record type. The page and the status filter are search params
// (constitution §5.6), so they survive reload and Back.
export interface LeadsTableSearch {
  readonly page?: number;
  readonly status?: string;
}

const MAX_STATUS = 64;

function validateTableSearch(raw: Record<string, unknown>): LeadsTableSearch {
  const page = Number(raw['page']);
  const status = typeof raw['status'] === 'string' ? raw['status'].trim() : '';
  return {
    ...(Number.isInteger(page) && page > 1 ? { page } : {}),
    ...(status !== '' && status.length <= MAX_STATUS ? { status } : {}),
  };
}

export const Route = createFileRoute('/_authed/leads/$type/')({
  validateSearch: validateTableSearch,
  component: lazyRouteComponent(
    () => import('../../../features/leads/screens.tsx'),
    'LeadsTableRoute',
  ),
});
